/**
 * Phase 2 — Parent-readable label map for activity subtypes.
 *
 * The analytics layer stores raw enum strings (QUIZ_PASSED, COURSE_STARTED,
 * ACHIEVEMENT_EARNED, ...). Never render those directly to a parent.
 */

export type ActivitySubtype =
  | "LESSON_COMPLETED"
  | "QUIZ_PASSED"
  | "QUIZ_FAILED"
  | "QUIZ_RETAKEN"
  | "COURSE_STARTED"
  | "COURSE_COMPLETED"
  | "ACHIEVEMENT_EARNED"
  | (string & {});

export function parentReadableSubtype(subtype: ActivitySubtype): string {
  switch (subtype) {
    case "LESSON_COMPLETED": return "Lesson completed";
    case "QUIZ_PASSED": return "Quiz passed";
    case "QUIZ_FAILED": return "Quiz attempted";
    case "QUIZ_RETAKEN": return "Quiz retaken";
    case "COURSE_STARTED": return "Course started";
    case "COURSE_COMPLETED": return "Course completed";
    case "ACHIEVEMENT_EARNED": return "Milestone earned";
    default:
      return subtype
        .toLowerCase()
        .split("_")
        .map((w) => (w ? w[0].toUpperCase() + w.slice(1) : w))
        .join(" ");
  }
}